export const emptyErrorCheck = (fieldsObj, formData, setErrorMessage) => {

    let errors = []
    fieldsObj.forEach((val) => {
        switch (val.type) {
            case "value": {
                if (val.dependencyField === null && (formData[val.fieldname].value === "" || formData[val.fieldname].value === null || formData[val.fieldname].value === undefined)) {
                    setErrorMessage(val.fieldname, val.label + " is mandatory")
                    errors.push(val)
                } else if (val.dependencyField !== null && (formData[val.fieldname].value === "" || formData[val.fieldname].value === null || formData[val.fieldname].value === undefined)) {
                    val.dependencyValues.some((depVal) => {
                        if (formData[val.dependencyField].value === depVal) {
                            if (formData[val.fieldname].value === "" || formData[val.fieldname].value === null || formData[val.fieldname].value === undefined) {
                                setErrorMessage(val.fieldname, val.label + " is mandatory")
                                errors.push(val)
                                return true; // This will stop further iterations (similar to break).
                            }
                        }

                    });

                }
                break
            }
            default: console.warn("type not found")
        }


    })
    return errors;
}